var render, staticRenderFns
import script from "./popupMultiple.vue?vue&type=script&lang=js&"
export * from "./popupMultiple.vue?vue&type=script&lang=js&"
import style0 from "./popupMultiple.vue?vue&type=style&index=0&id=2638d91e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2638d91e",
  null
  
)

export default component.exports